import { render, staticRenderFns } from "./Atelier.vue?vue&type=template&id=0bdab352&"
import script from "./Atelier.vue?vue&type=script&lang=js&"
export * from "./Atelier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports